import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { motion } from "framer-motion";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import Seo from "@/components/Seo";
import { metaForPath } from "@/lib/seo";
import { useLang } from "@/lib/i18n";
import { usePageTracking } from "@/lib/analytics";

export default function Layout({ children }) {
  const { pathname } = useLocation();
  const { lang } = useLang();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  usePageTracking(pathname);
  const meta = metaForPath(pathname);
  const isDetail = pathname.startsWith("/portfolio/") || pathname.startsWith("/insights/");

  return (
    <div className="App bg-obsidian min-h-screen">
      {/* Detail pages render their own <Seo> with dynamic content */}
      {!isDetail && <Seo title={meta.title} description={meta.description} path={pathname} noindex={meta.noindex} lang={lang} />}
      <Header />
      {/* Gold line sweep on route change */}
      <motion.div
        key={pathname + "-sweep"}
        className="fixed top-0 left-0 h-px bg-primary-gold z-[70]"
        initial={{ width: "100%", opacity: 1 }}
        animate={{ width: "0%", opacity: 0 }}
        transition={{ duration: 0.6, ease: [0.16, 1, 0.3, 1] }}
      />
      <motion.main
        key={pathname}
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5, ease: [0.16, 1, 0.3, 1] }}
      >
        {children}
      </motion.main>
      <Footer />
    </div>
  );
}
